<template>
  <b-form-group>
    <div class="flex items-center">
      <label
        v-if="label"
        class="p-0 w-[180px]"
      >
        {{ label }}
      </label>

      <v-select
        v-model="backgroundType"
        :options="[
          {
            value: null, 
            label: 'Fill', 
            icon: `<svg width=&quot;19&quot; height=&quot;19&quot; viewBox=&quot;0 0 19 19&quot; fill=&quot;none&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;><path fill-rule=&quot;evenodd&quot; clip-rule=&quot;evenodd&quot; d=&quot;M6.25068 8.01638C6.37375 8.14278 6.54067 8.21379 6.71472 8.21379C6.88877 8.21379 7.05569 8.14278 7.17876 8.01638C7.30183 7.88998 7.37097 7.71855 7.37097 7.5398V0.917211C7.37097 0.738459 7.30183 0.567028 7.17876 0.440631C7.05569 0.314234 6.88877 0.243225 6.71472 0.243225C6.54067 0.243225 6.37375 0.314234 6.25068 0.440631C6.12761 0.567028 6.05847 0.738459 6.05847 0.917211V7.5398C6.05847 7.71855 6.12761 7.88998 6.25068 8.01638ZM8.35144 1.92819V3.83557L14.0136 9.64938L12.5567 10.0025L6.96019 15.749L1.85588 10.5067L5.07544 7.20011V5.29273L0 10.5067L6.96019 17.6563L13.2156 11.2319L16.6123 10.4123L8.35144 1.92819ZM18.5548 16.3569C18.5767 16.6281 18.5408 16.901 18.4496 17.1565C18.3584 17.412 18.2141 17.644 18.0267 17.8365C17.8393 18.0289 17.6134 18.1771 17.3646 18.2708C17.1158 18.3644 16.8501 18.4013 16.5861 18.3788C16.322 18.4013 16.0563 18.3644 15.8075 18.2708C15.5587 18.1771 15.3328 18.0289 15.1454 17.8365C14.9581 17.644 14.8138 17.412 14.7226 17.1565C14.6314 16.901 14.5954 16.6281 14.6173 16.3569C14.6173 14.8472 16.5861 11.639 16.5861 11.639C16.5861 11.639 18.5548 14.8472 18.5548 16.3569Z&quot; fill=&quot;#333333&quot;/></svg>`
          }, 
          {
            value: 'gradient', 
            label: 'Gradient', 
            icon: `<svg width=&quot;20&quot; height=&quot;15&quot; viewBox=&quot;0 0 20 15&quot; fill=&quot;none&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;><rect x=&quot;1.03394&quot; y=&quot;0.5&quot; width=&quot;17.9612&quot; height=&quot;14&quot; fill=&quot;url(#paint0_linear_37:1340)&quot; stroke=&quot;black&quot;/><defs><linearGradient id=&quot;paint0_linear_37:1340&quot; x1=&quot;15.7845&quot; y1=&quot;1.46771&quot; x2=&quot;0.533936&quot; y2=&quot;1.46771&quot; gradientUnits=&quot;userSpaceOnUse&quot;><stop stop-color=&quot;white&quot;/><stop offset=&quot;1&quot;/></linearGradient></defs></svg>`
          }
        ]"
        :reduce="item => item.value"
        :searchable="false"
        class="w-100 position-relative custom-select"
        placeholder="Select color type"
        @option:selected="val => $emit('updated', val)"
      >
        <template #selected-option="option">
          <div class="d-flex align-items-center">
            <div
              class="mr-2"
              v-html="option.icon"
            />
            {{ option.label }}
          </div>
        </template>

        <template #option="option">
          <div class="d-flex align-items-center">
            <div
              class="mr-2"
              v-html="option.icon"
            />
            {{ option.label }}
          </div>
        </template>
      </v-select>
    </div>

    <slot />
  </b-form-group>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'BackgroundType',
  props: {
    value: {
      type: String
    },
    config: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default: 'Background Type'
    }
  },
  computed: {
    backgroundType: {
      get () {
        return _.get(this.config, 'backgroundType', null)
      },
      set (val) {
        this.$set(this.config, 'backgroundType', val)
      }
    }
  },
  watch: {
    value (val) {
      this.$emit('change', val)

      // Nothing selected -> reset
      if (!val) {
        this.backgroundType = null
        return
      }

      // If it's a string, keep old behaviour
      if (typeof val === 'string') {
        this.backgroundType = val.length > 3 ? 'gradient' : null
        return
      }

      // If it's an object (gradient config), treat it as gradient
      if (typeof val === 'object') {
        this.backgroundType = 'gradient'
        return
      }

      // Fallback
      this.backgroundType = null
    }
  }
}
</script>